import { useParams } from 'react-router-dom';

import ClinicalNotesTable from './ClinicalNotesTable';

const ClinicalNotesTableWrapper = ({ patient_id }) => {
  const { id } = useParams();
  const patientId = patient_id || id;

  return <ClinicalNotesTable patientId={patientId} />;
};

export default ClinicalNotesTableWrapper;
